// import { combineReducers } from "redux";
import {
	SET_THEME,
	SET_DARK,
	SET_LANG
} from './actions';

const initialState = {
	theme: '',
	lang: '',
	dark: '',
}

const mainReducer = (
	state = initialState,
	{ type, payload }
) => {
	switch (type) {
		case SET_THEME:
			return { ...state, theme: payload }
		case SET_DARK:
			return { ...state, dark: payload }
		case SET_LANG:
			return { ...state, lang: payload }
		default:
			return state
	}
}

export default mainReducer;
